/* globals bd */
define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.metroTagging = function () {

        // @ngInject
        /**
         * @param {ng.IHttpService} $http
         * @param {ng.ILogService} $log
         * @param {ng.IQService} $q
         */
        this.$get = function ($http, $log, $q, lpCoreUtils,metroMeta,metroUtils,metroContext) {
            var dataLayer=window.dataLayer=window.dataLayer || [];
            var environmentSetting=metroUtils.findEnvironment();
            var environmentAppType=metroMeta.ENVIRONMENT.APPTYPE.isWeb;
            function onpageLoadTag(pageName,pagePath,event) {
                var payload={
                    'environment':createEnvironment(),
                    'page':createPage(pageName,pagePath),
                    'event' : event
                }
                dataLayer.push(payload);


            }

            function sweepsOnPageLoadTag(pageName, pagePath, event) {
                var payload = {
                    'environment': createEnvironment(),
                    'page': createPage(pageName, pagePath),
                    'event': event,
                    'user': createUser()
                };
                dataLayer.push(payload);
            }

            function sweepsOnPageLoadEventTag(pageName, pagePath, eventName, eventAction, eventDetail, event) {
                var payload = {
                    'environment': createEnvironment(),
                    'page': createPage(pageName, pagePath),
                    'event': event,
                    'user': createUser(),
                    'attributes': createAttribute(eventName, eventAction, eventDetail)
                };
                dataLayer.push(payload);
            }

            function onpageLoadEventTag(pageName,pagePath,eventName,eventAction,eventDetail,event) {
                var payload={
                    'environment':createEnvironment(environmentSetting,environmentAppType),
                    'page':createPage(pageName,pagePath),
                    'attributes':createAttribute(eventName,eventAction,eventDetail),
                    'event' : event
                }
                dataLayer.push(payload);


            }
            function onEventTag(eventName,eventAction,eventDetail,event) {
                var payload={
                    'environment':createEnvironment(environmentSetting,environmentAppType),
                    'attributes' :createAttribute(eventName,eventAction,eventDetail),
                    'event' : event
                }
                dataLayer.push(payload);
            }
            function createAttribute(eventName,eventAction,eventDetail){
                var attributes={
                        'eventName':eventName,
                        'eventAction':eventAction,
                        'eventDetail':eventDetail
                }
                return attributes
            }
            function createPage(pageName,pagePath){
                var page={
                        'pageUrl':metroMeta.PAGEURL.pageURL+ pagePath,
                        'pageName':pageName,
                        'pagePath':pagePath,
                    }
                    return page
                }
                
            function createEnvironment(){
                var timeoffset = (new Date()).getTimezoneOffset() * 60000; 
                var localISOTime = (new Date(Date.now() - timeoffset)).toISOString().slice(0,-1);


                var environment={
                    'setting':environmentSetting,
                    'appType':environmentAppType,
                    'timeStamp':localISOTime
                }
                return environment
            }

            function createUser() {
                var user = {
                    'authLevel': metroUtils.checkAuthLevel() === '0' ? '0' : '1/2',
                };
                return user;
            }


            return {
                onpageLoadTag: onpageLoadTag,
                onEventTag: onEventTag,
                onpageLoadEventTag: onpageLoadEventTag,
                sweepsOnPageLoadTag: sweepsOnPageLoadTag,
                sweepsOnPageLoadEventTag: sweepsOnPageLoadEventTag
            };
        };

    };


});



// WEBPACK FOOTER //
// ./scripts/services/metroTaggingService.js